//ROUTER actions
export const ROUTER_LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

//SYSTEM actions
export const SYSTEM_WARMUP_API = 'SYSTEM_WARMUP_API';

//CART actions
export const CART_ADD_DISH = 'CART_ADD_DISH';
export const CART_INCREASE_DISH_COUNT = 'CART_INCREASE_DISH_COUNT';
export const CART_DECREASE_DISH_COUNT = 'CART_DECREASE_DISH_COUNT';
export const CART_CLEAN = 'CART_CLEAN';

//ORDER actions
export const ORDER_MODAL_SHOW = 'ORDER_MODAL_SHOW';
export const ORDER_MODAL_HIDE = 'ORDER_MODAL_HIDE';
export const ORDER_PAYMENT_TYPE_CHANGE = 'ORDER_PAYMENT_TYPE_CHANGE';
export const ORDER_CREATE = 'ORDER_CREATE';
export const ORDER_CREATE__SUCCESS = 'ORDER_CREATE__SUCCESS';
export const ORDER_CREATE__FAILURE = 'ORDER_CREATE__FAILURE';
export const ORDER_CONFIRM = 'ORDER_CONFIRM';
export const ORDER_CONFIRM__SUCCESS = 'ORDER_CONFIRM__SUCCESS';
export const ORDER_CONFIRM__FAILURE = 'ORDER_CONFIRM__FAILURE';
export const ORDER_CONFIRM__CANCEL = 'ORDER_CONFIRM__CANCEL';
export const ORDER_CLEAN = 'ORDER_CLEAN';

//ADDRESS actions
export const ADDRESS_CHANGED = 'ADDRESS_CHANGED';
export const ADDRESS_CLEAN = 'ADDRESS_CLEAN';


//SUBSCRIPTION actions
export const SUBSCRIPTION_MODAL_SHOW = 'SUBSCRIPTION_MODAL_SHOW';
export const SUBSCRIPTION_MODAL_HIDE = 'SUBSCRIPTION_MODAL_HIDE';
export const SUBSCRIPTION_CREATE = 'SUBSCRIPTION_CREATE';
export const SUBSCRIPTION_CREATE__SUCCESS = 'SUBSCRIPTION_CREATE__SUCCESS';
export const SUBSCRIPTION_CREATE__FAILURE = 'SUBSCRIPTION_CREATE__FAILURE';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js